export default __webpack_public_path__ + "static/footer-graphic-right-e00a931e5eb85db436c590a49c98f46f.png";